import { render, staticRenderFns } from "./IconShareSquare.vue?vue&type=template&id=05fa39e6"
import script from "./IconShareSquare.vue?vue&type=script&lang=js"
export * from "./IconShareSquare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports